import * as React from "react"

// import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

export default function Logo() {
  return (
    // <Link rel="noreferrer" to="#">
    <StaticImage
      src="../../images/logo.png"
      alt="Talent Juice"
      placeholder="blurred"
      layout="fixed"
      width={250}
      height={58}
    />
    // </Link>
  )
}